/**
 * 配車計画 ドライバー配車一覧
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocate/entries/drivers`

 const allocate_entry_driver_schedule = {
  namespaced: true,
  actions: {
    /**
     * 配車計画 ドライバー配車一覧
     * @param commit
     * @param driver_id
     * @param target_date
     * @returns {Promise<unknown>}
     */
    index ({ commit }, { driver_id, start_date, end_date }) {
      const api_path = `${API_PATH}/${driver_id}/dispatched_schedules`
      const params = { start_date: start_date, end_date: end_date }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},

 }

 export default allocate_entry_driver_schedule
